import * as angular from "angular";
import {AccountsContextService} from "../commons/services/accounts-context.service";

angular
  .module('bringoz.admin.point-of-sale')
  .config(pointOfSaleConfig);

/* @ngInject */
function pointOfSaleConfig($stateProvider) {

  $stateProvider

    // ******************************************
    // Point Of Sale - Site View
    // ******************************************

    .state('point-of-sale', {
      parent: 'bringoz.site',
      abstract: true,
      url: '/point-of-sale',
      // template: '<point-of-sale-view></point-of-sale-view>',
      template: '<ui-view></ui-view>',
      resolve: {
        account: (accountsContextService: AccountsContextService, splitService, site) => {
          return accountsContextService.getFavouriteAccount(splitService.getSiteId());
        }
        // printer: function(printerService: PrinterService) {
        //     return printerService.setLocalPrinters();
        // }
      }
    })


    // Create Delivery
    .state('point-of-sale.create-delivery', {
      url: '/create-delivery',
      controllerAs: 'vm',
      template: '<point-of-sale-create-delivery account="vm.account"></point-of-sale-create-delivery>',
      controller: function (triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Create Delivery"});
        triBreadcrumbsService.addCrumb({name: "Point of Sale"});
      }
    })


}
